import { useEffect } from 'react'

import useGetCheckoutUrl from '@lib/hooks/useGetCheckoutUrl'

import Spinner from '@components/Spinner'

export default function GetStartedCheckout() {
	const checkoutUrl = useGetCheckoutUrl()

	useEffect(() => {
		if (checkoutUrl && checkoutUrl !== '/') {
			window.open(checkoutUrl, '_self')
		}
	}, [checkoutUrl])

	return (
		<div className="flex flex-col items-center justify-center py-20">
			<Spinner />
			<p className="mt-4 text-gray-500">Redirecting to checkout...</p>
		</div>
	)
}
